import Vue from 'vue'
import post from '@/api/post/'

export default {
  login (params) {
    return post('authorization', {
      login_user: params.username.toLowerCase(),
      password_user: params.password
    }).then(response => {
      console.log(response)
      Vue.ls.set('token', response.data.token)
      Vue.ls.set('user_id', response.data.id_user)
      Vue.ls.set('email', response.data.email_user)
      return response
    }).catch(error => {
      this.logout(true)
      throw error
    })
  },
  logout (leaveServerToken) {
    const unsetStorage = () => {
      Vue.ls.remove('token')
      Vue.ls.remove('user_id')
      Vue.ls.remove('email')
      Vue.ls.remove('history')
      Vue.ls.remove('device')
      Vue.ls.remove('group')
      Vue.ls.remove('mapCenter')
      Vue.ls.remove('mapZoom')
    }
    if (!leaveServerToken) {
      return post('logout').then(unsetStorage)
    }

    return new Promise(resolve => {
      unsetStorage()
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/services/auth/index.js